// src/graphql/queries/otherQueries.js
// Miscellaneous queries

export const getPermissions = () => `query GetPermissions($module: String) {
    permissions(module: $module) {
        id
        name
        description
        module
        createdAt
        updatedAt
    }
}`;

export const getRolePermissions = () => `query GetRolePermissions($role: UserRole!) {
    rolePermissions(role: $role) {
        id
        role
        permissionId
        permission {
            id
            name
            description
            module
        }
        createdAt
        updatedAt
    }
}`;

export const getBetaSignups = () => `query GetBetaSignups($limit: Int, $offset: Int) {
    betaSignups(limit: $limit, offset: $offset) {
        id
        email
        firstName
        lastName
        companyName
        companySize
        jobTitle
        workEmail
        companyIndustry
        country
        annualTenderVolume
        interests
        linkedInProfile
        additionalInfo
        acceptTerms
        createdAt
        updatedAt
    }
}`;
